import { useState } from 'react';
// Einbetten eines YouTube-Players
// https://developers.google.com/youtube/player_parameters#enablejsapi

import { Typography } from "@material-ui/core";
import useCssMediaQuery from '../../useCssMediaQuery';

// ***************************************
// GoogleTagManager - Trigger Probleme
// ***************************************
// When GTM loads, the lazily loaded video (and the Youtube Iframe API script) are not present yet, 
// therefore, the listener never activates.
// https://www.analyticsmania.com/post/youtube-tracking-google-tag-manager-solved/

// An embedded video must be already present on a page when GTM container load
// Or the Youtube Iframe API script must be present on a page when GTM container loads

// So if one of these two things are present on a page, 
// then the YT listener will be activated and will start listening to video interactions.

// *** Loesung
// Load the Youtube API script before the Youtube Trigger is enabled.

const Video: React.FC = () => {
    let youTubeAllowed = window.CCM !== undefined && window.CCM.acceptedEmbeddings.length > 0 && window.CCM.acceptedEmbeddings.filter((a:any) => a.name === "Youtube Cookies (ytimg)").length > 0;
    const [consentMarketing, setConsentMarketing] = useState(youTubeAllowed);
    const cssMediaQuery = useCssMediaQuery();

    const youTubeWindowWith = cssMediaQuery.desktopVersion ? 560 : 360;

    /** Doku CCM19 Consent Manager siehe https://www.docs.ccm19.de//api/javascript-apis/ */

    window.addEventListener('ccm19EmbeddingAccepted', function (e:any) {
        let youTubeAllowed = window.CCM !== undefined && window.CCM.acceptedEmbeddings.length > 0 && window.CCM.acceptedEmbeddings.filter((a:any) => a.name === "Youtube Cookies (ytimg)").length > 0;
        setConsentMarketing(youTubeAllowed);
    });

    window.addEventListener('ccm19WidgetClosed', function (e:any) {
        let youTubeAllowed = window.CCM !== undefined && window.CCM.acceptedEmbeddings.length > 0 && window.CCM.acceptedEmbeddings.filter((a:any) => a.name === "Youtube Cookies (ytimg)").length > 0;
        setConsentMarketing(youTubeAllowed);
    });
    
    return (
        <>
            {consentMarketing === false &&
                <div>
                    <Typography variant={"body2"} color={"secondary"} onClick={() => { window.CCM.openWidget(); }} style={{ textDecoration: 'underline', cursor: 'pointer' }}>
                        Bitte Marketing-Cookies aktivieren, um das Video zu sehen.
                    </Typography>
                </div>
            }

            {consentMarketing === true &&
                <iframe width={youTubeWindowWith} height="315"
                    src="https://www.youtube.com/embed/MdNgBae0iLo?enablejsapi=1"
                    data-cookieconsent="marketing"
                    title="YouTube video player" frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen></iframe>
            }
        </>
    );
}

export default Video;